import { createFileRoute } from '@tanstack/react-router';

import { SignupPage } from '@/pages/auth';

export const Route = createFileRoute('/_guest/signup')({
  component: SignupPage,
});
